module.exports = __webpack_public_path__ + "img/maleGesture.2aa8f029.png";